<template>
  <div class="card-wrapper reasons-page-wrap">
    <ReasonsHeader />
    <div class="reasons-page container">
      <div class="row">
        <div class="page-introduction">
          <h4 class="page-introduction_title">Attractive codes</h4>
          <span class="page-introduction_subtitle"
            >with fiscal and administrative incentives in the mining, oil,
            tourism, agricultural and forestry sectors</span
          >
          <p class="page-introduction_description">
            In order to increase the contribution of growth-driving sectors to
            the national economy, Gabon is implementing a policy of
            attractiveness with the adoption of investment codes offering many
            advantages to international investors
          </p>
          <a
            href="https://a.storyblok.com/f/43998/x/92e81d5d28/reasons-to-invest-in-gabon-all.pdf"
            target="_blank"
            class="page-introduction_link"
            >Download full PDF</a
          >
        </div>
        <div class="page-content">
          <h3>
            Innovative codes to increase production, trade and investment flows
          </h3>

          <section class="section-odd">
            <div class="section-header">
              <span class="section-num">1</span>
              <span class="section-title"
                >The Government adopts a modern and attractive investment code
                to increase domestic and foreign investment
              </span>
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    Gabon has just adopted a law establishing a general
                    framework for investment that is being promulgated. The text
                    takes into account international best practices to increase
                    investor confidence.
                  </li>
                  <li>
                    The Code promotes advantages such as: investor
                    authorisation, equal treatment, freedom to carry out
                    investor activities, freedom to transfer capital, security
                    against expropriation, etc.
                  </li>
                </ul>
                <p>
                  <a href="https://www.gsez.com/" target="_blank"
                    >https://www.gsez.com/</a
                  >
                </p>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-9.png" />
              </div>
            </div>
          </section>

          <section class="section-even">
            <div class="section-header">
              <span class="section-num">2</span>
              <span class="section-title"
                >Implementation of a new mining code adapted to the standards
                accepted worldwide in the mining industry
              </span>
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    The new legal instrument takes into account the expectations
                    of mining operators: the reduction of corporate tax (IS)
                    from 35% to 30% of profits, with temporary tax exemptions
                    ranging from 3 to 8 years, depending on the life of the
                    projects, an exemption from customs duties on imported
                    equipment...
                  </li>
                  <li>
                    In addition, the purpose of the new code is to attract
                    socially and environmentally responsible companies
                  </li>
                </ul>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-10.png" />
              </div>
            </div>
          </section>

          <section class="section-odd">
            <div class="section-header">
              <span class="section-num">3</span>
              <span class="section-title"
                >Introducing a new, more attractive hydrocarbon code to
                encourage oil and gas investment in the country
              </span>
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    The new code gives investors more advantages, including
                    lower taxes: the total elimination of corporate income tax,
                    the reduction of the royalty rate, etc.
                  </li>
                  <li>
                    Another key measure taken by the code is the 10% reduction
                    in the State’s participation in the operator’s capital, the
                    possibility of establishing operating agreements on marginal
                    or mature deposits, etc.
                  </li>
                </ul>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-11.png" />
              </div>
            </div>
          </section>

          <section class="section-even">
            <div class="section-header">
              <span class="section-num">4</span>
              <span class="section-title"
                >Implementation of a new public procurement code to encourage
                private investment
              </span>
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    The public procurement system was reformed with the adoption
                    in 2018 of a new modern code that complies with
                    international standards.
                  </li>
                  <li>
                    The new legal instrument offers investors equal treatment in
                    the treatment of applications, free access to public
                    procurement and the application of transparent procedures
                    during procurement and contract execution.
                  </li>
                </ul>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-12.png" />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReasonsHeader from "./reasons-header.vue";

export default {
  name: "reasons-1",
  components: { ReasonsHeader },
};
</script>

<style scoped lang="scss" src="./reasons.scss"></style>
